export const getWebsite = state => state.websites.website;

export const getWebsites = state => state.websites.websites;

export const getTmpWebsite = state => state.websites.tmpWebsite;

export default getWebsite;
